import { render } from "./BranchHistory.vue?vue&type=template&id=d87eb490"
import script from "./BranchHistory.ts?vue&type=script&lang=js&external"
export * from "./BranchHistory.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__